export const FINANCE_TYPE_OPTIONS = [
  'Asset Finance',
  'Low Doc Asset Finance',
  'Business Loan',
];

export function normalizeFinanceType(value) {
  const v = (value || '').toLowerCase();
  if (v.includes('low') && v.includes('doc')) return 'low_doc_asset_finance';
  if (v.includes('business loan') || v.includes('unsecured') || v === 'business') return 'business_loan';
  if (v.includes('asset') || v.includes('equipment') || v.includes('vehicle') || v.includes('truck') || v.includes('machinery')) return 'asset_finance';
  return 'asset_finance';
}

export function financeRules(value) {
  const normalized = normalizeFinanceType(value);
  return {
    normalized,
    requiresAsset: normalized === 'asset_finance' || normalized === 'low_doc_asset_finance',
    requiresAssetQuote: normalized === 'asset_finance',
    requiresBankStatements: normalized === 'asset_finance' || normalized === 'business_loan',
    requiresFinancials: false,
    requiresId: true,
  };
}

export function requiredDocumentCategories(financeType, entityType = '') {
  const rules = financeRules(financeType);
  const categories = ['drivers_licence'];
  if (rules.requiresBankStatements) categories.push('bank_statements');
  if (rules.requiresAssetQuote) categories.push('asset_quote');

  const et = (entityType || '').toLowerCase();
  if (et.includes('trust')) {
    categories.push('trust_deed', 'asic_extract');
  } else if (et.includes('company')) {
    categories.push('asic_extract');
  } else if (et.includes('partnership')) {
    categories.push('partnership_agreement');
  }

  return Array.from(new Set(categories));
}

export function isConsumerFinanceType(value) {
  const v = (value || '').toLowerCase();
  return (
    v.includes('consumer') ||
    v.includes('personal') ||
    v === 'car loan' ||
    v === 'car loans'
  );
}
